// Uretilen videonun ComfyUI'deki dosyasi: diskteki yol + /view baglantisi.
//
// Yol kopyalanip Etsy'nin (ya da herhangi bir) dosya secme penceresinin
// "Dosya adi" kutusuna yapistirilinca dosya dogrudan secilir; indirmeye gerek
// kalmaz. Baglanti tarayicida acilir/yapistirilir.

import { useState } from "react";
import { Check, Copy, FolderOpen, Link2 } from "lucide-react";
import { localPathFor, parseOutputUrl } from "../../lib/comfyui";

function CopyRow({ icon: Icon, label, value, title }: { icon: React.ElementType; label: string; value: string; title: string }) {
  const [copied, setCopied] = useState(false);
  async function copy() {
    try { await navigator.clipboard.writeText(value); }
    catch {
      // Pano izni yoksa eski yol: gecici alan + execCommand
      const ta = document.createElement("textarea");
      ta.value = value; document.body.appendChild(ta); ta.select();
      document.execCommand("copy"); ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }
  return (
    <div className="flex items-center gap-1.5" title={title}>
      <Icon className="h-3.5 w-3.5 shrink-0 text-gray-400" />
      <span className="shrink-0 text-gray-500">{label}</span>
      <input readOnly value={value} onFocus={(e) => e.currentTarget.select()}
        className="min-w-0 flex-1 rounded border bg-gray-50 px-1.5 py-0.5 font-mono text-[11px] text-gray-700" />
      <button onClick={() => void copy()}
        className={`flex shrink-0 items-center gap-1 rounded border px-2 py-0.5 ${copied ? "border-emerald-300 bg-emerald-50 text-emerald-700" : "hover:bg-gray-50"}`}>
        {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />} {copied ? "Kopyalandı" : "Kopyala"}
      </button>
    </div>
  );
}

export function ComfyFileLink({ url, filename, subfolder, outputDir }: {
  url: string; filename?: string; subfolder?: string; outputDir: string;
}) {
  const ref = filename ? { filename, subfolder } : parseOutputUrl(url);
  const path = ref ? localPathFor(ref, outputDir) : null;
  return (
    <div className="space-y-1 text-xs">
      {path ? (
        <CopyRow icon={FolderOpen} label="Dosya" value={path}
          title="Etsy'de video eklerken açılan pencerenin 'Dosya adı' kutusuna yapıştır — dosya doğrudan seçilir" />
      ) : (
        <p className="text-[11px] text-amber-700">Dosya yolu için ayarlardan (⚙) ComfyUI çıktı klasörünü bir kez gir.</p>
      )}
      <CopyRow icon={Link2} label="Bağlantı" value={url} title="Tarayıcıda açılır (ComfyUI açıkken)" />
    </div>
  );
}
